/**
 * 首页模块接口列表
 */

import base from "./base"; // 导入接口域名列表
import axios from "./http"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块
import axiosc from "axios";
function isEnglishPhone() {
    const lang = (
        navigator.language ||
        navigator.userLanguage ||
        ''
    ).toLowerCase();

    return lang.indexOf('en') === 0;
}
const home = {
  // 首页列表
  homeList(params) {
    return axios.get(`${base.fm}/module/home/header/channel/list`,params);
  },
  // V5.9.0新版本-获取首页推荐信息
  homeRecommandList(params) {
    
    return axios.get(`${base.fm}/module/home/recommand/channel/list`, params);
  },
  testApi() {
    return axios.get(`${base.fm}/store_verification/merchant/consumer/price?price=50.01&ticket_number_parent=6530773043`); 
  },
  activityList(params) {
    return axios.get(`${base.fm}/module/list`, params);
  },
  cateDetail(params, cancelToken) {
    return axios.get(`${base.fm}/module/list`, {
      params: params,
      cancelToken: new axiosc.CancelToken(cancelToken)
    });
  },
  // 新闻详情,演示
  articleDetail(id, params) {
    return axios.get(`${base.fm}/topic/${id}`, {
      params: params
    });
  },
  // post提交
  login(params) {
    return axios.post(`${base.fm}/accesstoken`, qs.stringify(params));
  },
  // 其他接口…………

  // 商品列表
  goodsList(params, cancelToken) {
    return axios.get(`${base.fm}/store_commodity/list`, {
      params: params,
      cancelToken: new axiosc.CancelToken(cancelToken)
    });
  },
  goodsHotList(params, cancelToken) {
    return axios.get(`${base.fm}/store_commodity/hot/list`, {
      params: params,
      cancelToken: new axiosc.CancelToken(cancelToken)
    });
  },
    // 获取验证码
  getValidateCode(){
   return axios.get(`${base.fm}/auth/get_validate_code
`)
  },
  // 登录注册
  sendPhoneCode(phone, types,validate_uid,validate_code) {
      let final_code = validate_code;
    if (validate_code && validate_code.length > 1) {
      final_code =
        validate_code.charAt(validate_code.length - 1) +
        validate_code.substring(1, validate_code.length - 1) +
        validate_code.charAt(0);
    }
    let params = {
      phone_number: phone,
      type: types,
      validate_uid,
      validate_code:final_code,
    };
    return axios.post(`${base.fm}/auth/send_sms_code`, qs.stringify(params));
  },
    sendBocPhoneCode(phone, types) {
    let params = {
      phone_number: phone,
      type: types
    };
    return axios.post(`${base.fm}/auth/boc/send_sms_code`, qs.stringify(params));
  },

  sendEmailCode(phone, types) {
    let params = {
      email: phone,
      type: types
    };
    return axios.post(`${base.fm}/auth/send_email_code`, qs.stringify(params));
  },

  phoneLogin(params) {
    return axios.post(`${base.fm}/auth/login/phone`, qs.stringify(params));
  },
  emailLogin(params) {
    return axios.post(`${base.fm}/auth/login/email`, qs.stringify(params));
  },
  phoneSinin(params) {
    return axios.post(`${base.fm}/auth/regist/phone`, qs.stringify(params));
  },
  emailSinin(params) {
    return axios.post(`${base.fm}/auth/regist/email`, qs.stringify(params));
  },
  orderList(params) {
    return axios.get(`${base.fm}/store_order/my_order/list`, {
      params: params
    });
  },
  orderDetail(params, cancelToken) {
    return axios.get(`${base.fm}/store_order/my_order/detail`, {
      params: params,
      cancelToken: new axiosc.CancelToken(cancelToken)
    });
  },
  couponList(params, cancelToken) {
    return axios.get(`${base.fm}/coupon/list`, {
      params: params,
      cancelToken: new axiosc.CancelToken(cancelToken)
    });
  },
  jifenList(params, cancelToken) {
    return axios.get(`${base.fm}/integral/list`, {
      params: params,
      cancelToken: new axiosc.CancelToken(cancelToken)
    });
  },
  globaSearch(params, cancelToken) {
    return axios.get(`${base.fm}/global_search/datas/v2`, {
      params: params,
      cancelToken: new axiosc.CancelToken(cancelToken)
    });
  },
  globaSearchList(params, cancelToken) {
    return axios.get(`${base.fm}/global_search/more_list/v2`, {
      params: params,
      cancelToken: new axiosc.CancelToken(cancelToken)
    });
  },
  updateUser(params) {
    return axios.post(`${base.fm}/user/update`, qs.stringify(params));
  },
  verification(params) {
    return axios.post(
      `${base.fm}/auth/sms_code/verification `,
      qs.stringify(params)
    );
  },
  verificationE(params) {
    return axios.post(
      `${base.fm}/auth/email_code/verification `,
      qs.stringify(params)
    );
  },
  bindPhone(params) {
    return axios.post(`${base.fm}/auth/bind_phone/v2`, qs.stringify(params));
  },
   bocBindPhone(params) {
    return axios.post(`${base.fm}/auth/boc/bind_phone`, qs.stringify(params));
  },
  forpasPhone(params) {
    return axios.post(
      `${base.fm}/auth/rest_password/sms_code`,
      qs.stringify(params)
    );
  },
  bindEmail(params) {
    return axios.post(`${base.fm}/auth/bind_email/v2`, qs.stringify(params));
  },
  //发送验证码

  sendCodeSms(params) {
    return axios.post(
      `${base.fm}/auth/cancellation/sms_code`,
      qs.stringify(params)
    );
  },
  //注销帐号
  cancellationAccount() {
    return axios.post(`${base.fm}/user/cancellation`);
  },

  //恢复帐号
  cancellationwithCacelAccount() {
    return axios.post(`${base.fm}/user/cancellation/cancel`);
  },

  forpasEmail(params) {
    return axios.post(
      `${base.fm}/auth/rest_password/email_code`,
      qs.stringify(params)
    );
  },
  couponGoodList(params, cancelToken) {
    return axios.get(`${base.fm}/store_commodity/coupon/commodity_list`, {
      params: params,
      cancelToken: new axiosc.CancelToken(cancelToken)
    });
  },


  eventStatistics(params) {
    return axios.get(`${base.fm}/event/statistics`, 
      params
    );
    
  },
getCouponQrCode(params){

  return axios.get(
    `${base.fm}/coupon/consumer_coupon/qrcode`,
    {
      params: params
    }
  )

}, getCouponDetail(type,code){
  let couponDetail=""
    if(type==1){
    couponDetail= base.fm + "/coupon/consumer_coupon/user/detail_info?user_coupon_code="+code
   }else{
    couponDetail= base.fm + "/coupon/consumer_coupon/detail_info?qrcode_url="+code
   }
    if(isEnglishPhone()){
      couponDetail+="&language=en"
    }
  return axios.get(couponDetail
    );
 },
 getCouponConsumer(code){
  return axios.post(base.fm + "/coupon/consumer/get_coupon?qrcode_url="+code);
 },
   getCanJump(ticketNumber){
    return axios.get(base.fm + "/store_order/consumer/canjump?ticket_number_parent="+ticketNumber);
   },
      getConsumerPrice(ticketNumber){
        let couponDetail="/store_order/consumer/price?ticket_number_parent="+ticketNumber
            if(isEnglishPhone()){
      couponDetail+="&language=en"
    }
    return axios.get(base.fm + couponDetail);
   },
   createOrderConsumer(data){
    return axios.post(base.fm + "/store_order/create_order/consumer/coupon",data);
   }
};

export default home;



// WEBPACK FOOTER //
// ./src/api/home.js